// Generated by CoffeeScript 1.6.3
/**
 * Outdated browsers bar
 * https://browser-update.org/
*/

itsoftApp.createModule("browserUpdate", ["pageLoad"], function() {
  var load;
  window.$buoop = {
    c: 2
  };
  load = function() {
    return itsoftApp.loadScript("//browser-update.org/update.min.js", function() {
      return DEBUG && console.log("[module browserUpdate] script loaded");
    });
  };
  return itsoftApp.modules.pageLoad.addEvent(load);
});

/*
//@ sourceMappingURL=browserUpdate.map
*/
